var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('a',{staticClass:"btn btn-light btn-user btn-block font-weight-bold border auth_container",attrs:{"href":"/auth/redirect"}},[_c('img',{staticStyle:{"width":"20px","margin-right":"5px"},attrs:{"src":"/images/google.svg"}}),_c('span',{staticClass:"ml-1 auth_text"},[_vm._v("Continue with Google")])])])
}]

export { render, staticRenderFns }